import { CampaignDto } from '@shared/services/apiService';
import { CampaignRunStatusType } from '@shared/services/apiService/missing-types';
import { CampaignStatus } from './CampaignStatusButton';

type CampaignForStatus = { status?: CampaignDto['status'] | null } | null | undefined;

export const getCampaignStatus = (campaign: CampaignForStatus): CampaignStatus => {
  if (campaign?.status === CampaignRunStatusType.ACTIVE) return CampaignStatus.Dialing;
  return CampaignStatus.NotStarted;
};
